import type { SxProps, Theme } from '@mui/material/styles';

/**
 * Shared size for full edit dialogs (services, employees and resources). The
 * dialog keeps one width and height whatever it shows, so switching tabs or
 * adding fields never makes it jump; the content area scrolls instead.
 */
export const editDialogPaperSx = (fullScreen: boolean): SxProps<Theme> => ({
  borderRadius: fullScreen ? 0 : 4,
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  ...(fullScreen ? {} : {
    width: 'min(640px, calc(100vw - 64px))',
    maxWidth: 'none',
    height: 'min(760px, calc(100dvh - 64px))',
    maxHeight: 'none',
  }),
});

/** The scrolling middle of an edit dialog, between its fixed header and footer. */
export const editDialogContentSx: SxProps<Theme> = {
  flex: '1 1 auto',
  minHeight: 0,
  overflowY: 'auto',
};
